import { authFetch } from "../helpers/FetchHelpers";

const { default: DataService } = require("./DataService");

class WarehouseDataService extends DataService {
    constructor() {
        super("warehouse")
    }

    add(warehouse_name) {
        return super.add({
            warehouse_name,
        });
    }

    update(warehouse) {
        return super.add({
            "warehouse_id": warehouse.warehouse_id,
            "warehouse_name": warehouse.warehouse_name,
        })
    }

    getDetail(warehouseId) {
        return authFetch(process.env.REACT_APP_API_URL + '/warehouse/detail?warehouse_id=' + warehouseId, 'GET', null)
            .then((data) => {
                return {
                    warehouseId: data.data?.warehouse_id,
                    warehouseName: data.data?.warehouse_name,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    async getList(page, per_page, keyword) {
        return authFetch(process.env.REACT_APP_API_URL + '/warehouse/list', 'POST', JSON.stringify({
            page,
            per_page,
            warehouse_name: keyword
        }));
    }
}

export default WarehouseDataService;
